import React from 'react'
import {ensureNumber} from '@modifi/typescript-utils'
import {Svg, CommonSvgProps, commonDefaultProps} from '@modifi/ui'

const ratio = 20 / 23

type SingleEntityIconProps = CommonSvgProps

const SingleEntityIcon = React.forwardRef<SVGSVGElement, SingleEntityIconProps>(
  ({height = commonDefaultProps.height, width, ...props}, ref) => (
    <Svg
      viewBox="0 0 54 48"
      {...props}
      height={height}
      width={width ?? ensureNumber(height) / ratio}
      ref={ref}
    >
      <rect width="54" height="48" rx="4" fill="#15539F" />
    </Svg>
  )
)

export default SingleEntityIcon
